import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2ce3d6d0")

_pushScopeId("data-v-2ce3d6d0")
const _hoisted_1 = { class: "chart" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "chart-content",
      ref: "chartRef",
      style: {
        width: _ctx.width + 'px',
        height: _ctx.height + 'px',
        transform: `scale(${1 / _ctx.slideScale})`,
      }
    }, null, 4)
  ]))
})